import { ConfigurableFocusTrapFactory } from '@angular/cdk/a11y';
import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  OnInit
} from '@angular/core';

import { IrisIconButtonTypes } from '@sondermind/iris/icon-button';

import { IrisBaseModalComponent } from './base-modal/base-modal.component';
import { IrisModalRef } from './utilities/modal-ref';

@Component({
  selector: 'iris-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class IrisModalComponent<TContent, TModalInputs, TResponseData>
  extends IrisBaseModalComponent<TContent, TModalInputs, TResponseData>
  implements OnInit, AfterViewInit {
  title = '';

  irisIconButtonTypes = IrisIconButtonTypes;

  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(
    focusTrapFactory: ConfigurableFocusTrapFactory,
    hostElement: ElementRef,
    ref: IrisModalRef<TContent, TModalInputs, TResponseData>
  ) {
    super(focusTrapFactory, hostElement, ref);
  }

  ngOnInit(): void {
    this.title = this.ref.config.title ?? '';

    this.initializeModalContent();
  }

  @HostListener('document:keyup.escape', ['$event'])
  private escKeyPressed(): void {
    this.close();
  }

  close(): void {
    this.ref.close();
  }
}
